// Copyright 2026 Hardfin, Inc.
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { z } from 'zod';

const deleteMovementsResponseSchema = z
  .object({
    data: z.object({ deleted: z.number() }),
    metadata: responseMetadataSchema,
  })
  .transform(({ data }) => ({
    deleted: data.deleted,
  }));

type DeleteMovementsResponse = z.infer<typeof deleteMovementsResponseSchema>;

export async function deleteMovements(
  ids: string[]
): Promise<DeleteMovementsResponse> {
  const url = '/v1/move';
  const response = await api.delete(url, { data: { ids } });
  return parseResponse(deleteMovementsResponseSchema, response.data, {
    schemaName: 'DeleteMovements',
    endpoint: url,
  });
}
